// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orcamentos_AlterarStatusInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /orcamentos/alterar_status/{orc_id}/{status}
 *
 * No body; the orcamento ID and status arrive in URL segments.
 */
import { registerContract } from './validate'

export interface Orcamentos_AlterarStatusInput {}

registerContract('Orcamentos_AlterarStatusInput', {})
